var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"iframeContainer",staticClass:"iframe-newhero-container"},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.newHeroURL,"frameborder":"0","scrolling":"no","onload":_vm.resizeIframe(),"allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }